/// <reference path="../../../tools/typings/tsd.d.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export interface IDealerwareLookerService {
        loadFleetSnapshot(companyToken: string, locationId: number) : ng.IPromise<{}>;
        loadOpenContracts(locationCode: string) : ng.IPromise<{}>;
    }

    export class LookerService implements IDealerwareLookerService {
        public static $inject: string[] = [
            '$q',
            '$http',
            '$timeout',
            'LookerConfig',
            'DealerwareLookerQueryModel'
        ];

        constructor(public $q: any,
                    public $http: any,
                    public $timeout: any,
                    public LookerConfig: any,
                    public DealerwareLookerQuery: any) {}

        private get lookerModel() : string {
            return this.LookerConfig.model;
        }

        private query(data: any, promise: any, normalize: boolean) : void {
            var _self = this;

            this.DealerwareLookerQuery.create({
                promise: true,
                data: data
            }).then(
                function(response: any) {
                    if (normalize) { response.data = _self.normalize(response.data); }
                    promise.resolve(response);
                },
                function(response: any) { promise.reject(response); }
            );
        }

        private normalize(data: any) : any[] {
            $.each(data, function(idx: number, rec: any) {
                $.each(rec, function(key: string, value: any) {
                    rec[key.substring(key.indexOf('.') + 1)] = value;
                    delete(rec[key]);
                });
            });

            return data;
        }

        public loadFleetSnapshot(companyToken: string, locationId: number) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (!companyToken) {
                _deferred.reject({ response: { data: { message: 'Company Token is required' }}});
            } else {
                this.query({
                    model: this.lookerModel,
                    view: 'cars_dealerships',
                    fields: [ 'cars_dealerships.current_state', 'cars_dealerships.count' ],
                    filters: locationId ? { 'companies.token': companyToken, 'locations.id': locationId } : { 'companies.token': companyToken }
                }, _deferred, true);
            }

            return _deferred.promise;
        }

        public loadOpenContracts(locationCode: string) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (!locationCode) {
                _deferred.reject({ response: { data: { message: 'Location Code is required' }}});
            } else {
                this.query({
                    model: this.lookerModel,
                    view: 'car_dealership_reservations',
                    fields: [
                        'reservations.id',
                        'reservations.confirmation_token',
                        'reservations.ro_number',
                        'reservations.actual_pickup_date',
                        'cars.id',
                        'cars.license',
                        'cars.stock_number',
                        'trims.year',
                        'trims.model',
                        'customers.full_name',
                        'customers.first_name',
                        'customers.last_name',
                        'customers.id',
                        'service_advisor_profiles.full_name'
                    ],
                    sorts: [ 'reservations.actual_pickup_date asc' ],
                    filters: {
                        'pickup_location.code': locationCode,
                        'car_dealership_reservations.current_state': 'started',
                        'reservations.actual_pickup_date':'NOT NULL',
                        'reservations.actual_dropoff_date': 'NULL'
                    }
                }, _deferred, false);
            }

            return _deferred.promise;
        }
    }

    getDealerwareWebServicesModule().service('$dealerwareLookerService', LookerService);
}
